/**
 * Whether Form Settings untick 'strict recipients filtering'. The box is only shown for two or more groups, so the
 * setting is unticked when it is hidden or when fewer than two groups are left.
 * AD-2809: a live form keeps the setting it was made live with, as it cannot be changed on a live form. Unticking it
 * on a live form made every save of the form's other settings fail.
 */
export const shouldUntickStrictFiltering = ({isFormLive, hideStrictRecipientsFiltering, strictRecipientsFiltering, activeGroupCount}) =>
    !isFormLive && !!strictRecipientsFiltering && (hideStrictRecipientsFiltering || activeGroupCount <= 1);
